export default {
  production: {
    API_URL: "https://configurator.mag.archi/api/projects/",
  },
  local: {
    API_URL: "http://localhost:64838/api/projects/",
  },
  test: {
    API_URL: "https://mag.marbleit.rs/api/projects/",
  }
};
